import React from "react";
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import TenderProcessTracker from "../../components/TenderProcessTracker/TenderProcessTracker";
import { useParams } from "react-router-dom";
import { SourceDocuments }  from "../../components/TenderProcess"
import {
    SourceDocumentsPageContainer,
} from "./SourceDocumentsPage.styles";

export default function SourceDocumentsPage() {
    const { tenderId, subStep } = useParams();
    return (
        <SourceDocumentsPageContainer data-testid="main-content">
            <Breadcrumbs />
            <TenderProcessTracker />
            <SourceDocuments key={subStep} tenderId={tenderId} subStep={subStep}/>
        </SourceDocumentsPageContainer>
    );
}